<template>
  <div>
    <div v-if="!userAgent">
      <!-- banner -->
      <div class="banner">
        <img :src="image" alt />
      </div>
      <!-- tabs -->
      <div class="tabs1">
        <div class="tabs-title">
          <div>{{title}}</div>
          <div v-html="content"></div>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- banner -->
      <div class="banner1">
        <img :src="image" alt />
      </div>
      <!-- tabs -->
      <div class="tabs2">
        <div class="tabs-title2">
          <div>{{title}}</div>
          <div v-html="content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "details",
  data() {
    return {
      activeName: "1",
      image: "",
      title: "",
      content: "",
    };
  },
  methods: {
    tabClick: function (tab) {
      let url = "/show?c=" + tab.name;
      this.$root.newVue.$emit("nav_index", url);
      // this.$router.push(url);
    },
  },
  watch: {
    $route: {
      handler() {
        let url_arr = window.location.href.split("/");
        this.activeIndex = "/" + url_arr[url_arr.length - 1];
      },
      deep: true,
    },
  },
  mounted() {
    var that = this;
    let id = that.$route.query.id;
    let url_arr = window.location.href.split("/");
    that.activeIndex = "/" + url_arr[url_arr.length - 1];
    that.$http.get("cases/req?id=" + id).then(function (res) {
      that.content = res.data.data.content;
      that.title = res.data.data.title;
    });
    that.$http.get("images/cases").then(function (res) {
      that.image = res.data.data.image;
    });
  },
};
</script>
<style scoped lang="scss">
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.tabs1 {
  background: #f5f5f5;
  width: 100%;
  height: 100%;
  .tabs-title {
    width: 80%;
    margin: 0 auto;
    div:first-child {
      font-size: 20px;
      color: #333;
      line-height: 2rem;
      font-weight: bold;
      padding-top: 3rem;
    }
    div:nth-child(2) {
      margin-top: 2rem;
      padding-bottom: 3rem;
    }
    .img {
      width: 100%;
      margin-top: 3rem;
      img {
        width: 100%;
      }
    }
  }
}
.banner1 {
  width: 100%;
  img {
    width: 100%;
    height: 7rem;
  }
}
.tabs2 {
  background: #f5f5f5;
  width: 100%;
  height: 100%;
  .tabs-title2 {
    width: 90% !important;
    margin: 0 auto;
    div:first-child {
      font-size: 0.9rem;
      color: #333;
      line-height: 2rem;
      font-weight: bold;
      padding-top: 1rem;
    }
      div:nth-child(2) {
        margin-top: 1rem;
        padding-bottom: 2rem;
        font-size: 13px;
        line-height: 1rem;
      }
    }
    .img2 {
      width: 100%;
      margin-top: 3rem;
      img {
        width: 100%;
      }
    }
  }
</style>
<style>
.tabs1 .el-tabs__nav-scroll {
  overflow: hidden;
  height: 4rem;
  width: 80%;
  margin: 0 auto;
  line-height: 4rem;
}
.tabs1 .el-tabs__nav-scroll,
.tabs1 .el-tab-pane {
  width: 80% !important;
  margin: 0 auto;
}
.tabs1 .el-tabs__item {
  font-size: 18px;
  color: #333;
  font-weight: bold;
}
.tabs1 .el-tabs__content {
  overflow: hidden;
  position: relative;
  top: 0;
  bottom: 0;
  margin-top: -1%;
  padding-bottom: 6rem;
}
.tabs1 .tabs-title .title {
  width: 80%;
  margin: 0 auto;
  padding-top: 4rem;
}

.tabs1 .el-tabs__item:hover {
  color: #43ae82;
  cursor: pointer;
}

.tabs2 .el-tabs__nav-scroll {
  padding-bottom: 6px;
  height: 3rem;
  line-height: 3rem;
}
.tabs2 .el-tabs__nav-next {
  right: 0;
  margin-top: 2.5%;
}
.tabs2 .el-tabs__nav-prev {
  left: 0;
  margin-top: 2.5%;
}
.tabs2 .el-tabs__item {
  font-weight: bold !important;
}
.tabs2 .el-tabs__nav-scroll,
.tabs2 .el-tab-pane {
  width: 90%;
  margin: 0 auto;
}
.tabs2 .el-tabs__content {
  padding-bottom: 2rem !important;
}
</style>